import React from "react";
import "./mobileViewInfo.css";
import { infoConstant } from "./InfoConstant";
import UtilComponent from "./UtilComponent";

const InfoComponent = ({ step }) => {
   return <UtilComponent info={infoConstant(step)} />;
};

export default InfoComponent;
